<template>
  <div class="stat_cards -mx-4">
    <vs-row>
      <vs-col class="vx-col w-full md:w-1/4 px-4">
        <!-- Statistics Card -->
        <vs-card actionable class="cardx bg-green-500">
          <!-- header -->
          <div slot="header" class="mt-2 flex items-center justify-between">
            <div>
              <feather-icon icon="UsersIcon" class="p-3 inline-flex rounded-full text-primary mb-2" :style="{ background: `rgba(var(--vs-primary),.15)` }" />
              <span class="block font-semibold">Clients</span>
            </div>
            <h3>{{ stat_data.customer_count || 0 }}</h3>
          </div>

          <!-- action btn -->
          <p class="text-center mt-2" @click="$router.push({ name: 'client-list' }).catch(() => {})">View</p>
        </vs-card>
      </vs-col>

      <vs-col class="vx-col w-full md:w-1/4 px-4">
        <!-- Statistics Card -->
        <vs-card actionable class="cardx bg-green-500">
          <!-- header -->
          <div slot="header" class="mt-2 flex items-center justify-between">
            <div>
              <feather-icon icon="TruckIcon" class="p-3 inline-flex rounded-full text-success mb-2" :style="{ background: `rgba(var(--vs-success),.15)` }" />
              <span class="block font-semibold">Suppliers</span>
            </div>
            <h3>{{ stat_data.supplier_count || 0 }}</h3>
          </div>

          <!-- action btn -->
          <p class="text-center mt-2" @click="$router.push({ name: 'suppliers-list' }).catch(() => {})">View</p>
        </vs-card>
      </vs-col>

      <vs-col class="vx-col w-full md:w-1/4 px-4">
        <!-- Statistics Card -->
        <vs-card actionable class="cardx bg-green-500">
          <!-- header -->
          <div slot="header" class="mt-2 flex items-center justify-between">
            <div>
              <feather-icon icon="DollarSignIcon" class="p-3 inline-flex rounded-full text-danger mb-2" :style="{ background: `rgba(var(--vs-danger),.15)` }" />
              <span class="block font-semibold">Purchase Invoice</span>
            </div>
            <h3>$ {{ (stat_data.total_expense || 0) | currencyFilter }}</h3>
          </div>

          <!-- action btn -->
          <p class="text-center mt-2">View</p>
        </vs-card>
      </vs-col>

      <vs-col class="vx-col w-full md:w-1/4 px-4">
        <!-- Statistics Card -->
        <vs-card actionable class="cardx bg-green-500">
          <!-- header -->
          <div slot="header" class="mt-2 flex items-center justify-between">
            <div>
              <feather-icon icon="ShoppingCartIcon" class="p-3 inline-flex rounded-full text-warning mb-2" :style="{ background: `rgba(var(--vs-warning),.15)` }" />
              <span class="block font-semibold">Sales Invoice</span>
            </div>
            <h3>{{ stat_data.sale_count || 0 }}</h3>
          </div>

          <!-- action btn -->
          <p class="text-center mt-2">
            <span @click="$router.push({ name: 'pos-invoice-list' }).catch(() => {})">View</span>
          </p>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { paymentMixins } from '@/utils/paymentTypes'

export default {
  name: 'StateCards',

  async mounted() {
    // get dashboard state data
    await this.fetch_dashboard_state()
  },

  mixins: [paymentMixins],

  computed: {
    ...mapState('dashboard', ['stat_data'])
  },

  methods: {
    ...mapActions('dashboard', { fetch_dashboard_state: 'getDashboardStateData' })
  },
  // filters
  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    }
  }
}
</script>

<style></style>
